<div *ngIf="team$ | async as team" class="flex">
  <sbnb-subnav [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'statements-dashboard-onboarding'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main class="subnav__exists flex-1" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <section class="w-full h-full pt-16">
      <div
        class="onboarding-content p-12 max-w-4xl mx-auto border border-smoke-darkerlighter rounded bg-white relative z-10 box-shadow">
        <h1 class="mb-4">Get started with owner statements 🎉</h1>
        <p>Send monthly statements to your owners to inform them about their property's performance.</p>
        <div class="flex flex-row mt-8 space-x-2">
          <sbnb-button class="block" label="Take a tour" (click)="takeTour()"></sbnb-button>
          <sbnb-button
            [disabled]="!team.data"
            [matTooltip]="!team.data ? 'A team does not exist.' : ''"
            class="block"
            label="Get Started"
            [routerLink]="['../setup/new']"></sbnb-button>
        </div>
      </div>
    </section>
  </main>
</div>
